import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CarouselSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <UpdatesSection />
        <RankingSection />
        <AppSection />
        <IndexSection />
        <FAQSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}